export function withVendorAddedStatus(item, latestStatus = item.statusCode) {
  const wasVendorAdded = item.statusUpdates?.some((update) => update.status === 'Vendor Added');
  if (!wasVendorAdded || latestStatus === 'Vendor Added') return latestStatus;
  return latestStatus ? `Vendor Added · ${latestStatus}` : 'Vendor Added';
}
